import {Col, Form, Input, InputNumber, Row, Select} from "antd";
import {FC, useEffect} from "react";
import {VALIDATION_MESSAGES} from "../../../../enums/validationMessages";
import {ContactFormProps} from "./types";
import "./style.less"
import {
  EnvironmentOutlined,
  FieldNumberOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined,
  TagsOutlined
} from "@ant-design/icons";
import {CONTACT_ITEM_TYPES} from "../../../../enums/contactItemTypes";


const ContactForm: FC<ContactFormProps> = (props) => {
  const {contactController} = props
  const {form, selectedContactItem, contactTypeOptions, submitButtonHandler} = contactController
  const selectedType = Form.useWatch("type", form)

  useEffect(() => {
    if (selectedContactItem) {
      form.setFieldsValue(selectedContactItem)
    } else {
      form.resetFields()
    }
  }, [form, selectedContactItem])

  const valueSettings = () => {
    if (selectedType === CONTACT_ITEM_TYPES.PHONE) {
      return {prefix: <PhoneOutlined/>, placeholder: "+38 (___) ___-__-__", type: "tel"}
    }
    if (selectedType === CONTACT_ITEM_TYPES.EMAIL) {
      return {prefix: <MailOutlined/>, placeholder: "example@domain.com", type: "email"}
    }
    if (selectedType === CONTACT_ITEM_TYPES.LINK) {
      return {prefix: <LinkOutlined/>, placeholder: "https://example.com", type: "url"}
    }
    return {prefix: <EnvironmentOutlined/>, placeholder: "Введіть контактні дані", type: "text"}
  }

  const valueInput = valueSettings()


  return (
    <Form form={form} layout="vertical" className="contactItem_form"
          onFinish={submitButtonHandler}>
      <p className="contactItem_form__description">
        Вкажіть назву, тип і значення контакту. Порядковий номер визначає його місце у списку.
      </p>

      <Form.Item name="name" label="Назва контакту" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input size="large" prefix={<TagsOutlined/>} placeholder="Наприклад, Приймальне відділення"/>
      </Form.Item>

      <Form.Item name="value" label="Контактні дані" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input size="large" prefix={valueInput.prefix} placeholder={valueInput.placeholder} type={valueInput.type}/>
      </Form.Item>

      <Row gutter={14}>
        <Col xs={24} sm={14}>
          <Form.Item name="type" label="Тип контакту" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
            <Select size="large" options={contactTypeOptions} placeholder="Оберіть тип"/>
          </Form.Item>
        </Col>
        <Col xs={24} sm={10}>
          <Form.Item name="order" label="Порядок"
                     rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
            <InputNumber min={0} precision={0} controls className="order_field" size="large"
                         prefix={<FieldNumberOutlined/>} placeholder="№"/>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default ContactForm
